import PropTypes from 'prop-types';

export default PropTypes.shape({
  badge: PropTypes.string,
  colors: {
    font: PropTypes.string,
    background: PropTypes.string,
  },
  serviceTypeId: PropTypes.number,
  time: PropTypes.string,
  type: PropTypes.string,
  token: PropTypes.string,
});
